import { render, staticRenderFns } from "./CatalogHeaderBar.vue?vue&type=template&id=196fde31&scoped=true&lang=pug"
import script from "./CatalogHeaderBar.vue?vue&type=script&lang=js"
export * from "./CatalogHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./CatalogHeaderBar.vue?vue&type=style&index=0&id=196fde31&prod&lang=scss&scoped=true"
import style1 from "./CatalogHeaderBar.vue?vue&type=style&index=1&id=196fde31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196fde31",
  null
  
)

export default component.exports